import { render, staticRenderFns } from "./b-menu-item-bubble-actions.vue?vue&type=template&id=03221977&scoped=true&"
import script from "./b-menu-item-bubble-actions.vue?vue&type=script&lang=js&"
export * from "./b-menu-item-bubble-actions.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-item-bubble-actions.vue?vue&type=style&index=0&id=03221977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03221977",
  null
  
)

export default component.exports